import {environment} from '../../environments/environment';

/*
Moved this from the JS file
*/
class FdmUIHelper {
  init() {
    // console.log('fdm :: init()');
  }
  shower(id) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.remove('fdm-opacity-off', 'noshow');
      el.classList.add('fdm-opacity-high');
      // console.log('$ turned on', id);
    }
  }
  hider(id) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.add('fdm-opacity-off', 'noshow');
      el.classList.remove('fdm-opacity-high');
      // console.log('$ turned off', id);
    }
  }
  teller(id, msg) {
    const str = ' ' + String(msg);
    document.getElementById(id).innerHTML = str;
    // console.log('$ telling: ' + id, msg, str, document.getElementById(id));
  }
}

export class Log {

    static _a = 'color:#fff;background-color:red;font-size:15px;';
    static _b = 'color:#fff;background-color:green;font-size:15px;';
    static _c = 'color:#fff;background-color:blue;font-size:15px;';
    static _d = 'color:#fff;background-color:black;font-size:15px;';
    static _e = 'color:#fff;background-color:orange;font-size:15px;';
    
    static event ( source, message, ...args ) {
      this.msg ( this._e, source, message, ...args );
    }


    static msg ( ...args ) {

      for (var i = 0; i < arguments.length; i++) {
        console.log(arguments[i]);
      }

    }

}

export class ArrayUtil {
  static getLast = a => a[a.length - 1];
}

export class SceneActions {
  static flyCamera:string = 'flyCamera';
  static flyCameraReady:string = 'flyCameraReady';
}

export class Typical {
  static typemap = {
    'undefined' : 'undefined',
    'boolean'   : 'boolean',
    'number'    : 'number',
    'string'    : 'string',
    'function'  : 'function',
    'object'    : 'object',
    'Object'    : 'object',

    'Undefined' : 'undefined',
    'Null'      : 'null',
    'Boolean'   : 'boolean',
    'Number'    : 'number',
    'String'    : 'string',
    'Function'  : 'function',
    'Array'     : 'array',
    'StyleSheetList' : 'array'
  };
  static check(data) {

    if ( data === null      ) { return Typical.typemap['Null']; }
    if ( data === undefined ) { return Typical.typemap['Undefined']; }

    let type = typeof( data );
    let type_str = Typical.typemap[type];

    if ( type_str ) { return type_str; }

    type = {}.toString.call( data ).slice( 8, -1 );
    return Typical.typemap[ type ]
      || ( data instanceof Array ? 'Array' :
      ( data.propertyIsEnumerable(0) && data.length !== undefined
        ? 'Array' : 'Object' )
      );
  };
  static dumpProps( obj, name:string = null, depth:number = 0 ){

    let ret = [];
    if ( name ) {
      ret.push('-- '+name+' --');
    }
    if ( obj ) {
      Object.keys(obj).forEach ( key => {
        const type = typeof obj[key];
        if ( type == 'string' || type == 'boolean' || type == 'bigint' || type == 'number' ) {
          ret.push(key + ' [' + type + '] = ' + obj[key] );
        } else {
          if ( type == 'object' ) {
            const c = Object.keys(obj[key]);
            ret.push(key + ' [' + type + '] ('+c.length+')' );
            if ( depth < 5 ) {
              ret.push(Typical.dumpProps(obj[key]), type, depth + 1);
            }
            
          } else {
            ret.push(key + ' [' + type + ']' );
          }
        }
      });
    }
    return ret;
  }
}

export class Constants {

  static _fluff = 'font-size:11px;margin-right:1px;padding:4px 2px;';
  static _red = 'color:#fff;background-color:red;'+Constants._fluff;
  static _green = 'color:#fff;background-color:green;'+Constants._fluff;
  static _blue = 'color:#fff;background-color:blue;'+Constants._fluff;
  static _black = 'color:#fff;background-color:black;'+Constants._fluff;
  static _orange = 'color:#fff;background-color:orange;'+Constants._fluff;
  static _yellow = 'color:#222;background-color:yellow;'+Constants._fluff;
  static _purple = 'color:#fff;background-color:purple;'+Constants._fluff;
  static _pink = 'color:#fff;background-color:pink;'+Constants._fluff;
  static _gray = 'color:#444;background-color:#ccc;'+Constants._fluff;
  static _white = 'color:#444;background-color:#eee;'+Constants._fluff;

  static debug_on = !environment.production;
  static debug_off = false;

  static ONLY_COORDS:boolean = false;
  static COORDS_AND_ITEMS:boolean = true;

  // SJ cant use static text for translation to Japan
  //static UPLOAD_ERROR_MESSAGE: string = 'Error while uploading file ';
  //static UPLOAD_SUCCESS_MESSAGE: string = 'Successfully uploaded file ';
  //static PROJECT_FOLDER_NAME = ' Project Files';
  
  static ERROR_MESSAGE: string = 'GENERIC.ERROR';
  static SUCCESS_MESSAGE: string = 'GENERIC.SUCCESS';
  static SNACKBAR_DURATION = 4000;
  static DEFAULT_PROJECT_FOLDER = 'DEFAULT_PROJECT_FOLDER';
  static HANG_ON = new FdmUIHelper();

  static log:any = Log;
  
  static arrayGetLast = a => a[a.length - 1];

  static isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  static showHangOn() {
    Constants.HANG_ON.shower('hang-on');
  }
  static hideHangOn() {
    Constants.HANG_ON.hider('hang-on');
  }
  static tellHangOn( msg:string ) {
    Constants.HANG_ON.teller('hang-on-msg', msg);
    // console.log ( '!!!', Constants.HANG_ON);
  }


}
